/**
 * @generated SignedSource<<6eb8eff5b7e46fce800d70c452024a57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanyReviewCard_userReview$data = {
  readonly associatedWork: {
    readonly paidProjectProfile: {
      readonly client: {
        readonly avatarImage: {
          readonly id: string;
          readonly uid: string;
          readonly url: string;
        } | null;
        readonly displayUsername: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
      };
      readonly contractor: {
        readonly id: string;
      };
      readonly id: string;
    } | null;
  };
  readonly author: {
    readonly avatarImage: {
      readonly id: string;
      readonly uid: string;
      readonly url: string;
    } | null;
    readonly displayUsername: string;
    readonly firstName: string | null;
    readonly id: string;
    readonly lastName: string | null;
  };
  readonly createdAt: ContraAPIScalars.DateTime;
  readonly id: string;
  readonly isPositiveReview: boolean;
  readonly otherReviewsBySameAuthor: ReadonlyArray<{
    readonly createdAt: ContraAPIScalars.DateTime;
    readonly id: string;
    readonly reviewText: string | null;
  }> | null;
  readonly rating: number;
  readonly reviewText: string | null;
  readonly " $fragmentType": "CompanyReviewCard_userReview";
};
export type CompanyReviewCard_userReview$key = {
  readonly " $data"?: CompanyReviewCard_userReview$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyReviewCard_userReview">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewText",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUsername",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraImage",
  "kind": "LinkedField",
  "name": "avatarImage",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uid",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanyReviewCard_userReview",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPositiveReview",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UserReview",
      "kind": "LinkedField",
      "name": "otherReviewsBySameAuthor",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserReviewAssociatedWork",
      "kind": "LinkedField",
      "name": "associatedWork",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaidProjectProfile",
          "kind": "LinkedField",
          "name": "paidProjectProfile",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "UserProfile",
              "kind": "LinkedField",
              "name": "client",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserProfile",
              "kind": "LinkedField",
              "name": "contractor",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserReview",
  "abstractKey": null
};
})();

(node as any).hash = "412b4a6af9296cd2f7bcf70b146bb974";

export default node;
